import { GameModal } from "./GameModal";

interface Props {
  open: boolean;
  winnerNickname: string;
  abandoned?: boolean;
  onDismiss: () => void;
}

export function GameOverModal({ open, winnerNickname, abandoned, onDismiss }: Props) {
  return (
    <GameModal open={open} onClose={onDismiss} labelledBy="gameover-title">
      <h2 id="gameover-title" className="cw-title text-4xl font-bold text-orange-400">
        Partie terminée !
      </h2>
      <p className="text-2xl">
        {abandoned ? (
          "La partie est close."
        ) : (
          <>
            Victoire de <strong>{winnerNickname}</strong>
          </>
        )}
      </p>
      <p className="text-sm text-violet-300/70">
        Fermez cette fenêtre pour consulter le récapitulatif des frises.
      </p>
      <button type="button" className="cw-btn cw-btn-primary w-full" onClick={onDismiss}>
        Voir le récapitulatif
      </button>
    </GameModal>
  );
}
